import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { AutocompleteAddressField, SelectField, TextField } from '@roc/ui';
import { parseAddress } from '@roc/feature-utils';
import { ADDRESS_KEYS, ADDRESS_LABELS, addressLine, stateSelectOptions } from './entityReviewFields';
import { EntityFieldProps } from './entityFieldProps';

export const EntityAddressField = observer(({ store, item }: EntityFieldProps) => {
  const address = store.getExpected(item.itemName) ?? {};

  const handleAddressChange = event => {
    const { value, fullInfo } = event?.target || {};
    const { address_components, geometry } = fullInfo || {};
    const parsed = parseAddress(value, address_components, geometry);
    store.onExpectedChange(item.itemName, {
      ...address,
      address: value,
      streetNumber: parsed?.street_number ?? '',
      streetName: parsed?.street ?? '',
      city: parsed?.city ?? '',
      state: parsed?.state ?? '',
      zipCode: parsed?.zip ?? '',
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AutocompleteAddressField
          label={item.itemDisplayName}
          name={`${item.itemName}-address`}
          testId={`${item.itemName}-address`}
          value={address.address ?? addressLine(address)}
          onChange={handleAddressChange}
          standaloneLabel
          fullWidth
        />
      </Grid>
      {ADDRESS_KEYS.map(key => (
        <Grid item xs={12} sm={6} key={key}>
          {key === 'state' ? (
            <SelectField
              label={ADDRESS_LABELS[key]}
              value={address[key] ?? ''}
              onChange={value => store.onAddressFieldChange(item.itemName, key, value)}
              options={stateSelectOptions}
              name={`${item.itemName}-${key}`}
              testId={`${item.itemName}-${key}`}
              variant="outlined"
              fullWidth
              standaloneLabel
            />
          ) : (
            <TextField
              label={ADDRESS_LABELS[key]}
              value={address[key] ?? ''}
              onChange={e => store.onAddressFieldChange(item.itemName, key, e.target.value)}
              name={`${item.itemName}-${key}`}
              testId={`${item.itemName}-${key}`}
              variant="outlined"
              fullWidth
              standaloneLabel
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
});
